import dynamic from 'next/dynamic';

// Replace loadable() function with dynamic() function from Next.js
export default dynamic;
